import { useState } from "react";
import { supabase } from "../supabase";
import { toast } from "../Toast";
import { API_URL } from "../config/env";

export default function DeleteAccountBlock({ userId, userEmail, onDeleted }) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [typedEmail, setTypedEmail] = useState("");
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    if (typedEmail.trim().toLowerCase() !== (userEmail || "").trim().toLowerCase()) {
      toast.error("Email doesn't match. Type your account email exactly to confirm.");
      return;
    }
    setDeleting(true);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const token = session?.access_token;
      const res = await fetch(`${API_URL}/delete-account`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ user_id: userId, confirm_email: typedEmail }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.deleted) {
        toast.success("Account deleted. Signing you out...");
        // Clear local state + sign out
        try { localStorage.clear(); } catch (_) {}
        await supabase.auth.signOut().catch(() => {});
        setTimeout(() => { onDeleted && onDeleted(); window.location.href = "/"; }, 1200);
      } else {
        toast.error(data.detail || "Failed to delete account. Contact support@pitcherly.com.");
      }
    } catch (e) {
      console.warn("delete-account error:", e);
      toast.error("Could not connect to server. Email support@pitcherly.com if this keeps happening.");
    }
    setDeleting(false);
  };

  if (!confirmOpen) {
    return (
      <button
        className="acct-btn"
        style={{ marginTop: 10, background: "transparent", color: "#b91c1c", border: "1px solid #b91c1c" }}
        onClick={() => setConfirmOpen(true)}
      >
        Delete Account
      </button>
    );
  }

  return (
    <div style={{ marginTop: 12, padding: 12, border: "1px solid #b91c1c", borderRadius: 6, background: "rgba(185, 28, 28, 0.05)" }}>
      <div style={{ fontSize: 13, color: "var(--text)", marginBottom: 8, lineHeight: 1.5 }}>
        This is permanent. Your account, contacts, saved properties, and generation history will be deleted. Any active subscription will be cancelled.
      </div>
      <div style={{ fontSize: 12, color: "var(--text3)", marginBottom: 8 }}>
        Type <strong style={{ color: "var(--text)" }}>{userEmail}</strong> to confirm:
      </div>
      <input
        type="email"
        value={typedEmail}
        onChange={e => setTypedEmail(e.target.value)}
        placeholder="your@email.com"
        style={{ width: "100%", fontSize: 13, padding: "8px 10px", background: "#0d0d0d", border: "1px solid #2a2a2a", borderRadius: 6, color: "#e8e4dd", outline: "none", boxSizing: "border-box", marginBottom: 10 }}
      />
      <div style={{ display: "flex", gap: 8 }}>
        <button
          className="acct-btn"
          style={{ background: "#b91c1c", color: "#fff", border: "none", flex: 1 }}
          onClick={handleDelete}
          disabled={deleting}
        >
          {deleting ? "Deleting..." : "Permanently delete"}
        </button>
        <button
          className="acct-btn"
          style={{ background: "transparent", border: "1px solid #2a2a2a", flex: 1 }}
          onClick={() => { setConfirmOpen(false); setTypedEmail(""); }}
          disabled={deleting}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
